/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/9/5
 */
import request from 'crm/utils/request'
import api from 'crm/common/api/permissions'
import {stringify} from 'qs'
import {format} from 'utils/index'

export async function companyPermissions(params) {
    return request(`${api.companyPermissions.url}?${stringify(params)}`)
}

export async function companyPermissionsUpdate(params = {}) {
    return request(format(api.companyPermissionsUpdate.url, {id: params.id}), {
        method: api.companyPermissionsUpdate.type,
        body: params.body,
    })
}

export async function companyPermissionsCount(params) {
    return request(`${api.companyPermissionsCount.url}?${stringify(params)}`)
}

export async function companyPermissionsAll(params) {
    return request(`${api.companyPermissionsAll.url}?${stringify(params)}`)
}
